"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var loadRewards = function loadRewards(payload) {
  return {
    type: 'LOAD_REWARDS',
    payload: payload
  };
};

var loadRewardsSuccess = function loadRewardsSuccess(data) {
  return {
    type: 'LOAD_REWARDS_SUCCESS',
    payload: data
  };
};

var loadRewardsError = function loadRewardsError(error) {
  return {
    type: 'LOAD_REWARDS_ERROR',
    payload: {
      error: error
    }
  };
};

var loadRewardsReset = function loadRewardsReset() {
  return {
    type: 'LOAD_REWARDS_RESET'
  };
};

var loadReward = function loadReward(payload) {
  return {
    type: 'LOAD_REWARD',
    payload: payload
  };
};

var loadRewardSuccess = function loadRewardSuccess(data) {
  return {
    type: 'LOAD_REWARD_SUCCESS',
    payload: data
  };
};

var loadRewardError = function loadRewardError(error) {
  return {
    type: 'LOAD_REWARD_ERROR',
    payload: {
      error: error
    }
  };
};

var loadRewardReset = function loadRewardReset() {
  return {
    type: 'LOAD_REWARD_RESET'
  };
};

var loadRewardRedeemedUsers = function loadRewardRedeemedUsers(payload) {
  return {
    type: 'LOAD_REWARD_REDEEMED_USERS',
    payload: payload
  };
};

var loadRewardRedeemedUsersSuccess = function loadRewardRedeemedUsersSuccess(payload) {
  return {
    type: 'LOAD_REWARD_REDEEMED_USERS_SUCCESS',
    payload: payload
  };
};

var loadRewardRedeemedUsersError = function loadRewardRedeemedUsersError(error) {
  return {
    type: 'LOAD_REWARD_REDEEMED_USERS_ERROR',
    payload: {
      error: error
    }
  };
};

var loadRewardRedeemedUsersReset = function loadRewardRedeemedUsersReset() {
  return {
    type: 'LOAD_REWARD_REDEEMED_USERS_RESET'
  };
};

var createReward = function createReward(payload) {
  return {
    type: 'CREATE_REWARD',
    payload: payload
  };
};

var createRewardSuccess = function createRewardSuccess(rewardId) {
  return {
    type: 'CREATE_REWARD_SUCCESS',
    payload: rewardId
  };
};

var createRewardError = function createRewardError(error) {
  return {
    type: 'CREATE_REWARD_ERROR',
    payload: {
      error: error
    }
  };
};

var createRewardReset = function createRewardReset() {
  return {
    type: 'CREATE_REWARD_RESET'
  };
};

var editReward = function editReward(payload) {
  return {
    type: 'EDIT_REWARD',
    payload: payload
  };
};

var editRewardSuccess = function editRewardSuccess(rewardId) {
  return {
    type: 'EDIT_REWARD_SUCCESS',
    payload: rewardId
  };
};

var editRewardError = function editRewardError(error) {
  return {
    type: 'EDIT_REWARD_ERROR',
    payload: {
      error: error
    }
  };
};

var editRewardReset = function editRewardReset() {
  return {
    type: 'EDIT_REWARD_RESET'
  };
};

var deleteReward = function deleteReward(payload) {
  return {
    type: 'DELETE_REWARD',
    payload: payload
  };
};

var deleteRewardSuccess = function deleteRewardSuccess() {
  return {
    type: 'DELETE_REWARD_SUCCESS'
  };
};

var deleteRewardError = function deleteRewardError(error) {
  return {
    type: 'DELETE_REWARD_ERROR',
    payload: {
      error: error
    }
  };
};

var deleteRewardReset = function deleteRewardReset() {
  return {
    type: 'DELETE_REWARD_RESET'
  };
};

var extractReward = function extractReward(rewardId, clientId) {
  return {
    type: 'EXTRACT_REWARD',
    payload: {
      rewardId: rewardId,
      clientId: clientId
    }
  };
};

var extractRewardSuccess = function extractRewardSuccess(data) {
  return {
    type: 'EXTRACT_REWARD_SUCCESS',
    payload: {
      data: data
    }
  };
};

var extractRewardError = function extractRewardError(error) {
  return {
    type: 'EXTRACT_REWARD_ERROR',
    payload: {
      error: error
    }
  };
};

var extractRewardReset = function extractRewardReset() {
  return {
    type: 'EXTRACT_REWARD_RESET'
  };
};

var _default = {
  loadRewards: loadRewards,
  loadRewardsSuccess: loadRewardsSuccess,
  loadRewardsError: loadRewardsError,
  loadRewardsReset: loadRewardsReset,
  loadReward: loadReward,
  loadRewardSuccess: loadRewardSuccess,
  loadRewardError: loadRewardError,
  loadRewardReset: loadRewardReset,
  loadRewardRedeemedUsers: loadRewardRedeemedUsers,
  loadRewardRedeemedUsersSuccess: loadRewardRedeemedUsersSuccess,
  loadRewardRedeemedUsersError: loadRewardRedeemedUsersError,
  loadRewardRedeemedUsersReset: loadRewardRedeemedUsersReset,
  createReward: createReward,
  createRewardSuccess: createRewardSuccess,
  createRewardError: createRewardError,
  createRewardReset: createRewardReset,
  deleteReward: deleteReward,
  deleteRewardSuccess: deleteRewardSuccess,
  deleteRewardError: deleteRewardError,
  deleteRewardReset: deleteRewardReset,
  editReward: editReward,
  editRewardSuccess: editRewardSuccess,
  editRewardError: editRewardError,
  editRewardReset: editRewardReset,
  extractReward: extractReward,
  extractRewardSuccess: extractRewardSuccess,
  extractRewardError: extractRewardError,
  extractRewardReset: extractRewardReset
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map